import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Col, Form, Input, Row, Table } from "antd";
import { Content } from "antd/es/layout/layout";
import { PlusOutlined } from "@ant-design/icons";

const dataSource = [
  {
    name: "Form 1",
  },
  {
    name: "Form 2",
  },
  {
    name: "Form 3",
  },
  {
    name: "Form 4",
  },
  {
    name: "Form 5",
  },
  {
    name: "Form 6",
  },
  {
    name: "Form 7",
  },
];

const TemplateCreatePage = () => {
  const { t } = useTranslation();
  return (
    <Content>
      <Row justify="center">
        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <Form labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
            <Form.Item name="name" label={t("Name")}>
              <Input placeholder={t("Input name..")} style={{ width: "40%" }} />
            </Form.Item>
            <Form.Item name="shortName" label={t("Short name")}>
              <Input
                placeholder={t("Input short name..")}
                style={{ width: "40%" }}
              />
            </Form.Item>
          </Form>
          <Row justify="space-between" align="middle">
            <Col>
              <h2>{t("Forms")}</h2>
            </Col>
            <Col>
              <Button type="primary" icon={<PlusOutlined />}>
                {t("Add new")}
              </Button>
            </Col>
          </Row>
          <Table bordered dataSource={dataSource}>
            <Table.Column dataIndex="name" title={t("Name")} width="95%" />
            <Table.Column render={() => <a>{t("Edit")}</a>} />
            <Table.Column render={() => <a>{t("Delete")}</a>} />
          </Table>
        </Col>
      </Row>
    </Content>
  );
};

export default TemplateCreatePage;
